import React, { useEffect, useState } from "react"
import parse from "html-react-parser"
import { Container } from "react-bootstrap"
import {
  faLinkedinIn,
  faFacebookF,
} from "@fortawesome/free-brands-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as styles from "./PostContent.module.css";

const PostContent = ({ data }) => {
  const [currentUrl, setCurrentUrl] = useState("")

  useEffect(() => {
    if (typeof window !== "undefined") {
      setCurrentUrl(window.location.href)
    }
  }, [])
  return (
    <div className="article-news">
      <Container className="">
        {!!data?.content && (
          <section itemProp="articleBody" className={styles.content}>
            {parse(data?.content)}
          </section>
        )}
        <ul className="social-media d-flex gap-3 d-flex align-items-baseline">
          <li className={`share-title `}>Share</li>
          <li>
            <a
              href={`https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faFacebookF} style={{color: "#000",}} />
            </a>
          </li>
          <li>
            <a
              href={`https://twitter.com/home?status=${currentUrl}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.15281 6.92812L14.2525 1H13.0439L8.616 6.14719L5.07925 1H1L6.34822 8.78356L1 15H2.20859L6.88481 9.56439L10.6198 15H14.699L9.15248 6.92812H9.15281ZM7.49753 8.85203L6.95558 8.077L2.64402 1.90978H4.50033L7.97966 6.887L8.5215 7.66203L13.0445 14.1316H11.1884L7.49753 8.85236V8.85203Z"
                  fill="#000"
                ></path>
              </svg>
            </a>
          </li>
          <li>
            <a
              href={`https://www.linkedin.com/shareArticle?mini=true&url=${currentUrl}&title=${
                data?.title
              }&summary=${data?.excerpt || ""}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faLinkedinIn} style={{color: "#000",}}  />
            </a>
          </li>
        </ul>
        <hr />
      </Container>
    </div>
  )
}

export default PostContent
